<div class="contents-title" [class.opened]="contentDisplay">
    {{contentDisplay ? content?.name : ''}}
</div>
<div class="contents-display" [class.opened]="contentDisplay">
    <ng-template [ngIf]="content != null && contentDisplay">
        <div class="contents-items-list" *ngIf="!contentOpened">
            <div class="contents-item" *ngFor="let item of content.subContent" (click)="openSubContent(item)">
                <div class="contents-item-image">
                    <img [src]="'../../assets/' + item.image"/>
                </div>
                <div class="contents-item-title">
                    {{item.name}}
                </div>
            </div>
        </div>
        <div class="item-content" *ngIf="contentOpened">
            <div class="item-content-title">
                <div class="item-content-back-button" (click)="openSubContent(null)"></div>
                <div class="item-content-title-text">
                    {{contentOpened.name}}
                </div>
            </div>
            <div class="item-content-body">
                <div class="item-content-item" *ngFor="let subItem of contentOpened.subContent">
                    <div class="contents-item-image" [style.background-image]="'url(../../assets/' + subItem.image + ')'" (click)="openMoreInfoPopup($event)" (mouseleave)="closeMoreInfoPopup()">
                    </div>
                    <div class="contents-item-title">
                        {{subItem.name}}
                    </div>
                    <div class="contents-item-text" [innerHTML]="subItem.content">
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>